import {
  IBodyProductSearch,
  IBodyProductSearchTemp,
  ICatalogState,
} from 'interfaces/catalog.interface';

const bodyProductSearchTemp: IBodyProductSearchTemp = {
  options: {
    brand_id: [],
    client_id: [],
    csv_format: false,
    favorite: null,
    with_images: null,
    search: [],
    language_id: '',
    order: ['date+'],
    group: [],
    limit: 30,
    index: 0,
  },
  filter: {
    reference: [],
    color: [],
    season: [],
    segmentation: [],
    division: [],
    family: [],
    gender: [],
    pvi: [],
    pvpr: [],
    tag: [],
    tier: [],
  },
};

const bodyProductSearch: IBodyProductSearch = JSON.parse(
  JSON.stringify(bodyProductSearchTemp)
);

const initialCatalogState: ICatalogState = {
  catalogItems: null,
  relatedProducts: null,
  productItem: null,
  isLoading: true,
  isLoadingRelatedProducts: false,
  isLoadingMoreProducts: false,
  isLoadingProduct: true,
  isLoadingSetBodyProduct: true,
  bodyProductSearch: bodyProductSearch,
  bodyProductSearchTemp: bodyProductSearchTemp,
  querysearchArray: [],
  thereAreMoreProducts: true,
  isEmptyProducts: false,
  brandSelected: null,
  filtersLengths: {
    brand: 0,
    color: 0,
    gender: 0,
    division: 0,
    family: 0,
    season: 0,
  },
  filtersLengthsTemp: {
    brand: 0,
    color: 0,
    gender: 0,
    division: 0,
    family: 0,
    season: 0,
  },
  querySearch: '',
  setQuerySearch: () => {},
  addToBodySearch: () => Promise.resolve(false),
  removeFromBodySearch: () => Promise.resolve(false),
  removeAllFromBodySearch: () => Promise.resolve(false),
  removeFromBodySearchFilter: () => Promise.resolve(false),
  setSortBy: () => Promise.resolve(false),
  getCatalog: () => Promise.resolve(false),
  addMoreProductsToCatalog: () => Promise.resolve(false),
  applyFilters: () => Promise.resolve(false),
  addBodyFilters: () => {},
  removeBodyFilters: () => {},
  resetTempBodyFilters: () => {},
  addBodyBrandOptions: () => {},
  removeBodyBrandOptions: () => {},
  resetPriceSlider: () => {},
  addToQuerySearchArray: () => {},
  removeFromQuerySearchArray: () => {},
  resetBodyFilters: () => Promise.resolve(false),
  setPriceSliders: () => {},
  getProduct: () => Promise.resolve(false),
  getProductsByBrands: () => Promise.resolve(false),
  setFavorites: () => {},
  addLike: () => Promise.resolve(false),
  isLoadingAddLike: {
    productId: '',
    isLoading: false,
  },
  removeLike: () => Promise.resolve(false),
  isLoadingRemoveLike: {
    productId: '',
    isLoading: false,
  },
  getRelatedProducts: () => Promise.resolve(false),
  resetCatalog: () => {},
  formatView: '5',
  setFormatView: () => {},
};

export default initialCatalogState;
